import React from "react"
import { RowAlign, View } from "./types"
import { LinebreakStrategy, Resolution, Unit, useLinebreak } from "../gpu"


const useTemplateEngine = () => {
    const render = (children: View, variables: { [key: string]: string } = {}, align: null | { orientation: RowAlign, resolution: Resolution} = null, linebreak?: LinebreakStrategy.Word ): Unit[][] => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const applyLinebreak = useLinebreak({ strategy: linebreak })

        let grid: Unit[][] = []

        children.split('\n').map((row => {

            Object.keys(variables).forEach((variableName) => {
                row = row.replace(`$${variableName}`, variables[variableName])
            })

            let characters: string[] | null = row.match(/\[(?:.,)+.\]|./g)
            let breakedGrid: Unit[][] = []
            
            if (Array.isArray(characters)) {
                breakedGrid = [characters]
            } else {
                
                breakedGrid = [[]]
            }
            if (align !== null) {
                // Apply Linebreak
                if (linebreak) {
                    breakedGrid = applyLinebreak(breakedGrid, 0, align.resolution)
                }

                // Apply Align
                breakedGrid = breakedGrid.map(breakedRow => {
                    let alignedRow = [...breakedRow]
                    switch(align.orientation) {
                        case RowAlign.Left:
                            break;
                        case RowAlign.Center:
                            if (align.resolution.width > alignedRow.length) {
                                alignedRow = [...Array(Math.ceil((align.resolution.width - alignedRow.length) / 2)).fill(' '), ...alignedRow]
                            }
                            break;
                        case RowAlign.Right:
                            if (align.resolution.width > alignedRow.length) {
                                alignedRow = [...Array(align.resolution.width - alignedRow.length).fill(' '), ...alignedRow]
                            }
                            break;
                    }

                    return alignedRow
                })

               
            }
            
            breakedGrid = breakedGrid.map((breakedRow) => {
                if (!breakedRow) return []
                return breakedRow.map(character => {
                    if (typeof character !== "string") return character
                    if (character.length > 1) {
                        return character.replace(/\[|\]/g, '').split(',')
                    }
                    return character
                })
            })

            if (breakedGrid.length < 0) {
                grid.push([[' ']])
            } else {
                breakedGrid.forEach(row => {
                    grid.push(row)
                })
            }
        }))
        return grid

    }

    return render
}

export default useTemplateEngine